import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class AppStore {

  private readonly SESSION_KEY_LANG = 'lang';
  private readonly SESSION_KEY_DARK_MODE = 'darkMode';
  private readonly isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  saveLang(lang: string): void {
    if (this.isBrowser) {
      localStorage.setItem(this.SESSION_KEY_LANG, lang);
    }
  }

  getLang(): string | null {
    if (this.isBrowser) {
      return localStorage.getItem(this.SESSION_KEY_LANG);
    }
    return null;
  }

  clearLang(): void {
    if (this.isBrowser) {
      localStorage.removeItem(this.SESSION_KEY_LANG);
    }
  }

  saveDarkMode(mode: string): void {
    if (this.isBrowser) {
      localStorage.setItem(this.SESSION_KEY_DARK_MODE, mode);
    }
  }

  getDarkMode(): boolean {
    if (this.isBrowser && localStorage.getItem(this.SESSION_KEY_DARK_MODE)) {
      const str = localStorage.getItem(this.SESSION_KEY_DARK_MODE);
      return ((str === undefined) || (str === null) || (str?.toLowerCase() === 'true'));  
    }
    return true;
  }

  clearDarkMode(): void {
    if (this.isBrowser) {
      localStorage.removeItem(this.SESSION_KEY_DARK_MODE);
    }
  }
}